import { useThesaurusBlock } from "@/hooks/api/useThesaurus";
import parse from "html-react-parser";
import Layout from "@/components/Layout/Layout";
import Loading from "@/components/Loading/Loading";
import Link from "@/components/LangLink/LangLink";

export default function Creditos() {
    const { data, isLoading, error } = useThesaurusBlock(37);
    const term = data?.[0]?.term || '';
    const body = data?.[0]?.body || '';

    if (isLoading) return <Layout><Loading /></Layout>
    if (error) return <Layout><Loading error={true}/></Layout>

    return (
        <Layout>
            <div className="has-background-white bottom-shadow py-7">
                <div className="wrapper wrapper--narrow is-relative">
                    <Link to="/" className="close-btn top-0" aria-label="Cerrar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M36 12 12 36M12 12l24 24"/></g></svg>
                    </Link>
                    <div className="pt-6">
                        <div className="flow--l text-base">
                            <h1 className="has-text-weight-semibold is-capitalized">{term.toLowerCase()}</h1>
                            <div>{parse(body)}</div>
                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    )
}